import styled from 'styled-components'
import { Button as MuiButton } from '@mui/material'

export const Button = styled(MuiButton)`
  margin-right: ${(p) => p.theme.spacing(1)};
`
